import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue'),
    },
    {
        path: '/services',
        name: 'Services',
        component: () => import('../views/Services.vue'),
    },
    {
        path: '/services/electrical',
        name: 'Electrical',
        component: () => import('../views/services/Electrical.vue'),
    },
    {
        path: '/services/power',
        name: 'Power',
        component: () => import('../views/services/Power.vue'),
    },
    {
        path: '/services/datacenter',
        name: 'Datacenter',
        component: () => import('../views/services/Datacenter.vue'),
    },
    {
        path: '/services/automation',
        name: 'Automation',
        component: () => import('../views/services/Automation.vue'),
    },
    {
        path: '/services/fire-safety',
        name: 'FireSafety',
        component: () => import('../views/services/FireSafety.vue'),
    },
    {
        path: '/clients',
        name: 'Clients',
        component: () => import('../views/Clients.vue'),
    },
    {
        path: '/projects',
        name: 'Projects',
        component: () => import('../views/Projects.vue'),
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/Contact.vue'),
    },
    // Catch-all route
    { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;